import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ColumnHeading,
  SortBy,
  TableColumnsKeys,
} from '../ColumnHeading/ColumnHeading';

type TTableHeader = {
  readonly key: SortBy['key'];
  readonly label: ReactNode;
  readonly defaultSortOrder: SortBy['direction'];
};

const TABLE_HEADERS: readonly TTableHeader[] = [
  {
    key: TableColumnsKeys.SUBSIDIARY,
    label: <FormattedMessage defaultMessage="Subsidiary" id="+8minw" />,
    defaultSortOrder: 'ASC',
  },
  {
    key: TableColumnsKeys.SHELF,
    label: <FormattedMessage defaultMessage="Shelf" id="Bsa2Wy" />,
    defaultSortOrder: 'ASC',
  },
  {
    key: TableColumnsKeys.PLAYER,
    label: <FormattedMessage defaultMessage="Player" id="1AGL1r" />,
    defaultSortOrder: 'ASC',
  },
  {
    key: TableColumnsKeys.STATUS,
    label: <FormattedMessage defaultMessage="Status" id="tzMNF3" />,
    defaultSortOrder: 'ASC',
  },
];

type Props = {
  readonly setSortBy: React.Dispatch<React.SetStateAction<SortBy>>;
  readonly sortBy: SortBy;
};

export const TableHeader = ({ setSortBy, sortBy }: Props) => (
  <thead>
    <tr>
      {TABLE_HEADERS.map(({ defaultSortOrder, key, label }) => (
        <th key={key}>
          <ColumnHeading
            defaultSortOrder={defaultSortOrder}
            setSortBy={setSortBy}
            sortBy={sortBy}
            sortKey={key}
          >
            {label}
          </ColumnHeading>
        </th>
      ))}
    </tr>
  </thead>
);
